




import { Vue, Component, Prop } from 'vue-property-decorator'
import Status from '@/classes/Status'

@Component
export default class HIVEStatusDropDownList extends Vue {
  @Prop(Object) private value: Status

  private get selectedStatus() {
    // return this.value && this.value.intValue !== 0
    //   ? this.statusList.find((s: Status) => s.intValue === this.value.intValue)
    //   : this.statusList.find((s: Status) => s.intValue === 100)
    return this.statusList.find((status: Status) => status.intValue === this.value)
  }

  private set selectedStatus(val: Status) {
    this.$emit('select', val)
  }

  private get statusList() {
    return this.$store.getters['uicontrols/getStatusList']
  }

  private created() {
    this.$store.dispatch('uicontrols/getStatusListAsync')
  }
}
